/** The query parameter every marketing-site link into the app carries (ID-0021). */
export const LANGUAGE_QUERY_PARAM = "lang";

/**
 * The language the URL asks for, normalised ("DE-at" → "de-AT"), when it is one the app
 * supports; null otherwise. An explicit choice on the marketing site outranks the stored and
 * the detected language, so the caller treats the result like a manual choice.
 */
export const readLanguageFromQuery = (
  search: string,
  supportedLanguages: readonly string[],
  supportedVariants: readonly string[]
): string | null => {
  const raw = new URLSearchParams(search).get(LANGUAGE_QUERY_PARAM)?.trim();
  if (!raw) return null;
  const [base, region] = raw.split("-");
  const normalised = region ? `${base.toLowerCase()}-${region.toUpperCase()}` : base.toLowerCase();
  if (region ? supportedVariants.includes(normalised) : supportedLanguages.includes(normalised)) {
    return normalised;
  }
  return null;
};

/**
 * The language to apply given the URL's and the stored choice: a base language from the URL
 * keeps a stored regional variant of that same language (a German-site link must not move an
 * Austrian "de-AT" user to "de-DE"); anything else from the URL replaces the stored choice.
 */
export const applyQueryLanguage = (queryLanguage: string | null, stored: string | null): string | null => {
  if (!queryLanguage) return null;
  if (stored && stored.includes("-") && !queryLanguage.includes("-") && stored.split("-")[0] === queryLanguage) {
    return stored;
  }
  return queryLanguage;
};
